export default "__VITE_ASSET__Stzyu8vB__"